"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function EmptyDataSection(props) {
  var title = props.title,
      anchor = props.anchor;
  var hCName = (0, _classnames.default)('font-normal', {
    'anchor-section': !!anchor
  });
  return _react.default.createElement("div", {
    className: "px-5 py-2 sm:py-4 sm:px-8 text-gray-600 bg-gray-200"
  }, _react.default.createElement("h4", {
    className: hCName,
    id: anchor
  }, title));
}

EmptyDataSection.propTypes = {
  title: _propTypes.default.string.isRequired,
  anchor: _propTypes.default.string
};
EmptyDataSection.defaultProps = {
  anchor: null
};

var _default = _react.default.memo(EmptyDataSection);

exports.default = _default;